/* 


@PRAKT


   _____________________________________________________________

   |
   | HCC SLIDESHOW
   |
   _____________________________________________________________
*/

/* ______________________________________________________________

   |
   | CLASS
   |
   ______________________________________________________________
*/

export default class HCCSlideshow {

    constructor() {
        this.init();
    }

    init() {
        this.video_list = document.querySelectorAll( '.slideshow__swiper video' );
        this.setupVideoSlideshow();
        this.scrollObserver();
        this.killVideo();
        // this.test();
    }

    check() {
        this.video_list.forEach( v => {
            console.log( v.paused );
            if( !v.paused ) console.log( v.querySelector( 'source' ) );
            
        } );
        console.log('---');
    }

    test() {        
        setTimeout( () => {
            this.check();
            this.test();
        }, 2000 );
    }

    setupVideoSlideshow() {
        setTimeout( () => {
            this.video_list.forEach( v => {
                const parent = v.parentNode.parentNode.parentNode.parentNode;
                if( !parent.classList.contains( 'slider__item--current' ) ) v.pause();
            } );
        }, 200 );
    }

    scrollObserver() {
        let options = {
            rootMargin: '0px',
            threshold: 0.2
        };
        let callback = ( entries, observer ) => {
            entries.forEach( ( entry ) => {
                ( entry.isIntersecting ) ? entry.target.play() : entry.target.pause();
            } );
        };
        this.scroll_observer = new IntersectionObserver( callback, options );
        this.video_list.forEach( e => {
            this.scroll_observer.observe( e );
        });
    }

    killScrollObserver() {
        this.video_list.forEach( e => {
            this.scroll_observer.unobserve( e );
        });
        this.scroll_observer.disconnect();
    }

    killVideo() {
        if( this.video_list.length < 1 ) return;
        window.addEventListener("beforeunload", () => {
            console.log('🔪 Slideshow');
            this.video_list.forEach( v => {
                v.pause();
                v.removeAttribute('src');
                v.load();
            });
        });
    }
}

// const hccslideshow = new HCCSlideshow();